var ARROWS_POSITION = {
    ON_GALLERY: 0,
    OUTSIDE_GALLERY: 1,
};
export default ARROWS_POSITION;
//# sourceMappingURL=arrowsPosition.js.map